import React from 'react';
import { portfolioList } from './portfolioData';
import './PortfolioProjects.css';

const PortfolioProjects = ({ items, category }) => {
  // for show 4 items
  const limit = items ? items : portfolioList.length;

  const filteredProjects =
    category === 'all'
      ? portfolioList
      : portfolioList.filter((project) => project.category === category);

  return (
    <section className="container mx-auto mt-2 md:mt-0">
      <div>
        <div className="project-container flex flex-wrap justify-center text-center items-center">
          {filteredProjects.slice(0, limit).map(({ name, img, liveLink }) => (
            <a
              className="project-card w-[40%] h-[500px] p-3 m-3 transition border relative cursor-pointer"
              href={liveLink}
              target="_blank"
              rel="noreferrer"
            >
              <div className="project-img-container w-full h-[500px] overflow-hidden">
                <img
                  className="project-img w-full h-[95%] grayscale transition"
                  src={img}
                  alt="project-images"
                />
              </div>

              <div className="project-title opacity-0 w-[75%] h-10 absolute top-12 -left-7 bg-back  text-primary">
                <h2>{name}</h2>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioProjects;
